/**
 * Anzeige-Formatierung. Rechnen findet hier nicht statt (Spec 10.7).
 *
 * Die API liefert Beträge als String mit Punkt (`1234.50`). Diese Funktionen
 * machen daraus die deutsche Schreibweise, ohne je durch `Number` zu gehen.
 */

/** `1234.50` → `1.234,50` */
export function money(value: string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "–";
  const negative = value.startsWith("-");
  const [intPart = "0", frac = "00"] = value.replace("-", "").split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${negative ? "−" : ""}${grouped},${frac.padEnd(2, "0").slice(0, 2)}`;
}

export function euro(value: string | null | undefined): string {
  const formatted = money(value);
  return formatted === "–" ? formatted : `${formatted} €`;
}

/** `4.13` → `4,13 h` */
export function hours(value: string | null | undefined): string {
  if (value === null || value === undefined || value === "") return "–";
  return `${value.replace(".", ",")} h`;
}

/** `2026-07-18` → `Sa 18.07.2026` */
export function longDate(iso: string): string {
  return `${weekdayDate(iso)}${iso.slice(0, 4)}`;
}

/** `2026-07-18` → `Sa 18.07.` — ohne Jahr, etwa für den Nachbartag. */
export function weekdayDate(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number) as [number, number, number];
  const date = new Date(y, m - 1, d);
  const weekday = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"][date.getDay()];
  return `${weekday} ${String(d).padStart(2, "0")}.${String(m).padStart(2, "0")}.`;
}

/** `2026-07-18` → `18.07.` */
export function shortDate(iso: string): string {
  const [, m, d] = iso.split("-");
  return `${d}.${m}.`;
}

export function dateTime(iso: string | null): string {
  if (!iso) return "–";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** Ist der Betrag negativ? Für die farbliche Hervorhebung. */
export function isNegative(value: string | null | undefined): boolean {
  return typeof value === "string" && value.startsWith("-");
}

/** Ist der Betrag null oder „0.00"? */
export function isZero(value: string | null | undefined): boolean {
  return value === null || value === undefined || /^-?0(\.0+)?$/.test(value);
}

/** `2026-07` → `Juli 2026` */
export function monthName(month: string): string {
  const [y, m] = month.split("-");
  const namen = [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember",
  ];
  return `${namen[Number(m) - 1] ?? m} ${y}`;
}
